import { render, staticRenderFns } from "./ItemStopCoop.vue?vue&type=template&id=3aade770&scoped=true&"
import script from "./ItemStopCoop.vue?vue&type=script&lang=js&"
export * from "./ItemStopCoop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aade770",
  null
  
)

export default component.exports